import { Box, Button, ButtonGroup, Card, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PageHeader } from '../../../app/AppStyles';
import ContentSelector from '../../subcomponents/ContentSelector';
import { deleteSchoolclassesToUnlink, fetchSchoolclassesToLink, fetchSchoolclassGroup, fetchSchoolclassGroups, postSchoolclassesToLink, resetSchoolclassGroupStatus } from './schoolclassGroupSlice';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    width: { xs: '90%', md: '40%' },
    maxHeight: '90%',
    boxShadow: 24,
};

export default function SchoolclassGroupLinkCard({ handleClose, schoolclassGroupId, addMode, deleteMode, currentSchoolclasses }) {
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.user);
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { schoolclassGroupsLinksPost, schoolclassGroupsLinksDelete, schoolclassToLink } = useSelector((state) => state.management.schoolclassGroup);

    const [selectedSchoolclasses, setSelectedSchoolclasses] = useState([]);

    useEffect(() => {
        if (addMode) dispatch(fetchSchoolclassesToLink(schoolclassGroupId));
    }, [dispatch, schoolclassGroupId]);

    // Post status callback
    useEffect(() => {
        if (schoolclassGroupsLinksPost.status === "success") {
            dispatch(resetSchoolclassGroupStatus());
            dispatch(fetchSchoolclassGroup(schoolclassGroupId));
            handleClose();
        } else if (schoolclassGroupsLinksPost.status === "failed") {
            dispatch(resetSchoolclassGroupStatus());
        };
    }, [dispatch, handleClose, schoolclassGroupsLinksPost.status]);

    // Delete status callback
    useEffect(() => {
        if (schoolclassGroupsLinksDelete.status === "success") {
            dispatch(resetSchoolclassGroupStatus());
            dispatch(fetchSchoolclassGroup(schoolclassGroupId));
            handleClose();
        } else if (schoolclassGroupsLinksDelete.status === "failed") {
            dispatch(resetSchoolclassGroupStatus());
        };
    }, [dispatch, handleClose, schoolclassGroupsLinksDelete.status]);

    const handleAddClick = () => {
        let tempObject = {};

        tempObject.schoolclassGroupId = schoolclassGroupId;
        tempObject.createdBy = `AP/${user.number}`;
        tempObject.schoolclasses = selectedSchoolclasses;

        dispatch(postSchoolclassesToLink(tempObject));
    };

    const handleDeleteClick = () => {
        let tempObject = {};

        tempObject.schoolclassGroupId = schoolclassGroupId
        tempObject.createdBy = `AP/${user.number}`;
        tempObject.schoolclasses = selectedSchoolclasses;

        dispatch(deleteSchoolclassesToUnlink(tempObject));
    };

    return (
        <Box sx={{ ...modalStyle }}>
            <Card sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto', p: 2 }}>
                <Stack spacing={1} sx={{ flex: '1 1 auto' }}>
                    <Typography variant="h6" sx={{ ...PageHeader }}>{resourceFinal[appLanguage].words.CLASSES} {addMode ? resourceFinal[appLanguage].words.ADD.toLowerCase() : resourceFinal[appLanguage].words.DELETE.toLowerCase()}</Typography>
                    <ContentSelector
                        content={addMode ? schoolclassToLink.data : deleteMode ? currentSchoolclasses : []}
                        contentId="schoolclassId"
                        contentTitle={resourceFinal[appLanguage].words.CLASSES}
                        contentHeaders={[resourceFinal[appLanguage].words.NAME]}
                        contentRows={["schoolclassName"]}
                        selectedContent={selectedSchoolclasses}
                        setSelectedContent={setSelectedSchoolclasses}
                        multiple
                    />
                    <ButtonGroup sx={{ justifyContent: 'center' }}>
                        <Button variant="outlined" color="error" onClick={handleClose}>{resourceFinal[appLanguage].words.CANCEL}</Button>
                        {deleteMode && <Button disabled={setSelectedSchoolclasses.length === 0} variant="outlined" color="primary" onClick={handleDeleteClick}>{resourceFinal[appLanguage].words.DELETE}</Button>}
                        {addMode && <Button disabled={setSelectedSchoolclasses.length === 0} variant="outlined" color="primary" onClick={handleAddClick}>{resourceFinal[appLanguage].words.ADD}</Button>}
                    </ButtonGroup>
                </Stack>
            </Card>
        </Box>
    );
}
